import type { TrProps } from 'components/ui-blocks/table';
import { Td, Tr } from 'components/ui-blocks/table';
import React from 'react';
import { getDepthStyle } from '../helpers';
import styles from '../TableWidget.module.scss';

interface Props extends TrProps {
  /**
   * The number of visible columns in the table.
   */
  columnCount: number;

  /**
   * The message displayed by this row.
   * @default "Loading …"
   */
  message?: string;
}

const TableWidgetPlaceholderRow: React.FC<Props> = ({
  columnCount: columns,
  depth = 0,
  message = 'Loading …',
}) => (
  <Tr className={styles.placeholder}>
    <Td colSpan={columns * 2} style={getDepthStyle(depth)}>
      {message}
    </Td>
  </Tr>
);

export default TableWidgetPlaceholderRow;
